import { Component } from 'react';
import { connect } from 'react-redux';
import { CONVERSATION_MODE } from "../../../pages/MessagePage/constants";
import { messageActions } from "../../../pages/MessagePage/reducer";
import { addRouterListener } from "../../../util/library/Router";
import { zIndex } from '../../../util/varibles/constants';
import Conversations from "./Component/Conversations";
import Messages from "./Component/Messages";
import styles from './style.module.scss';

const mapStateToProps = null

interface IProps {
    updateConversations(payload: { conversation: any, mode: CONVERSATION_MODE, isTop?: boolean }): void

    getChat(payload: { index: number, isClear: boolean }): void

    getChatOfOp(payload: { index: number, isClear: boolean }): void

    setNewConversationType: typeof messageActions.setNewConversationType
}

class MessageMini extends Component<IProps> {
    state = {
        isInvisible: window.location.pathname.includes('message')
    }
    listen: any;

    constructor(props: IProps) {
        super(props);
        this.props.getChat({ index: 1, isClear: true });
        this.props.getChatOfOp({ index: 1, isClear: true });

        this.listen = addRouterListener((state) => {
            const { pathname = '' } = state.location || {};
            const isInvisible = pathname.includes('message');
            this.setState({ isInvisible });
            if (!isInvisible)
                this.props.setNewConversationType();
        })
    }

    componentWillUnmount() {
        if (this.listen)
            this.listen();
    }

    handleOpenConversation = (conversation: any) => {
        this.props.updateConversations({ conversation, mode: CONVERSATION_MODE.OPEN });
        const { id } = conversation.group_chat;
        setTimeout(() => {
            const el = document.getElementById('input-' + id);
            if (el)
                el.focus();
        }, 100);
    }

    render() {
        const { isInvisible } = this.state;

        if (isInvisible)
            return null;

        return <div className={styles.wrapper} style={{ zIndex: zIndex.message }}>
            <Conversations />
            <Messages onOpenConversation={this.handleOpenConversation} />
        </div>;
    }
}

export default connect(mapStateToProps, {
    updateConversations: messageActions.updateConversations,
    getChat: messageActions.getChat,
    getChatOfOp: messageActions.getChatOfOpRequest,
    setNewConversationType: messageActions.setNewConversationType
})(MessageMini);
